<template>
  <h3 class="text-3xl md:text-5xl font-bold px-8 pt-16 pb-6">
    <slot />
  </h3>
</template>
